import { useState, useMemo } from "react";
import { Search } from "lucide-react";
import { PRODUCTS } from "../data/site";
import ProductCard from "../components/ProductCard";

export default function Products() {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return PRODUCTS;
    return PRODUCTS.filter(
      (p) =>
        p.name.toLowerCase().includes(q) ||
        p.short.toLowerCase().includes(q) ||
        p.tags.some((t) => t.toLowerCase().includes(q))
    );
  }, [query]);

  return (
    <div data-testid="products-page">
      <section className="bg-[#0A192F] text-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="slash-divider"></span>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#0EA5E9]">Catalogue</span>
          </div>
          <h1 className="font-head font-black text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-4xl">
            Every spare your plant runs on.
          </h1>
          <p className="mt-5 text-white/70 max-w-2xl text-lg">
            Search across {PRODUCTS.length} product categories — from conveyor belts to trolley
            wheels.
          </p>

          <div className="mt-10 max-w-xl relative">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50" />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search bearings, belts, gear box, V-belts..."
              data-testid="products-search"
              className="w-full bg-white/5 border border-white/15 focus:border-[#0EA5E9] text-white placeholder-white/40 pl-11 pr-4 py-4 outline-none"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#475569] mb-6" data-testid="products-count">
            Showing {filtered.length} of {PRODUCTS.length} categories
          </div>
          {filtered.length === 0 ? (
            <div className="py-20 text-center text-[#475569]">
              No products match &ldquo;{query}&rdquo;. Try another keyword.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((p, i) => (
                <ProductCard key={p.slug} product={p} index={i} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
